import React, { useEffect, useState } from "react";
import Pagination from "../../Components/Pagination/Pagination";

import { useRef } from "react";
import "../Transactions/loaderstyle.css";
import LocalLoader from "../../Components/Loader/LocalLoader";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { CustomerTxnRefund, CustomerTxnSatausUpdate, getCustomerTxn } from "../../utils/api";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import DatePicker from "react-datepicker";
import {
  getDateFromDateObj,

  isEmpty,
  pdfData,
} from "../../utils/common";
import { TableWrapper } from "../../Components/styledConstant";
import { useLocation, useNavigate } from "react-router-dom";
import raiseTicket from "../../assets/images/raise_ticket.svg";
import AsideLeft from "../../Components/AsideLeft/AsideLeft";
import { useSelector } from "react-redux";
import { AlertWrapper } from "../../Components/Modal/style";
import Lottie from "react-lottie";
import modalpopup from "../../assets/images/modalPopubg.svg";
import animationData1 from "../../assets/lotties/question.json";
import { ModalPopUp } from "../../Components/ModalPopUp/ModalPopUp";
import ConfirmBox from "../../Components/ConfirmBox/ConfirmBox";
import MoreOptions from "../../Components/MoreOptions/MoreOptions";
import DateRangePicker from "../../Components/DateRangePicker/DateRangePicker";
require("react-datepicker/dist/react-datepicker.css");

const csvHeader = [
  { label: "Customer Name", key: "userFullName" },
  { label: "Mobile No.", key: "userMobileNumber" },
  { label: "Transaction ID", key: "txnId" },
  { label: "Amount", key: "amount" },
  { label: "Date", key: "transactionDate" },
  { label: "Service Type", key: "serviceType" },
  { label: "Route", key: "route" },
  { label: "Status", key: "status" },
];

const statusList = [
  {
    label: "Success",
    value: "SUCCESS",
  },
  {
    label: "Refunded",
    value: "REFUNDED",
  },
  {
    label: "Pending",
    value: "PENDING",
  },
  {
    label: "Refund Pending",
    value: "REFUND_PENDING",
  },
  {
    label: "Fail",
    value: "FAIL",
  },
];
const subscribedService = [
  {
    label: "BBPS",
    value: "BBPS",
  },

  {
    label: "Recharge",
    value: "RECHARGE",
  },
];
const routeType = [
  {
    label: "Select route",
    value: "",
  },
  {
    label: "Broadband Postpaid",
    value: "BROADBAND POSTPAID",
  },
  {
    label: "Cable TV",
    value: "CABLE TV",
  },
  {
    label: "Clubs & Associations",
    value: "CLUBS AND ASSOCIATIONS",
  },
  {
    label: "Credit Card",
    value: "CREDIT CARD",
  },
  {
    label: "Donation",
    value: "DONATION",
  },
  {
    label: "DTH",
    value: "DTH",
  },
  {
    label: "Education fees",
    value: "EDUCATION FEES",
  },
  {
    label: "Electricity",
    value: "ELECTRICITY",
  },
  {
    label: "Fasttag",
    value: "FASTAG",
  },

  {
    label: "Gas",
    value: "GAS",
  },

  {
    label: "Health Insurance",
    value: "HEALTH INSURANCE",
  },
  {
    label: "Hospital",
    value: "HOSPITAL",
  },
  {
    label: "Hospital and Pathology",
    value: "HOSPITAL AND PATHOLOGY",
  },
  {
    label: "Housing society",
    value: "HOUSING SOCIETY",
  },

  {
    label: "Insurance",
    value: "INSURANCE",
  },
  {
    label: "Landline postpaid",
    value: "LANDLINE POSTPAID",
  },

  {
    label: "Life Insurance",
    value: "LIFE INSURANCE",
  },
  {
    label: "Loan Repayment",
    value: "LOAN REPAYMENT",
  },
  {
    label: "LPG Gas",
    value: "LPG GAS",
  },

  {
    label: "Mobile postpaid",
    value: "MOBILE POSTPAID",
  },
  {
    label: "Mobile Prepaid",
    value: "MOBILE PREPAID",
  },

  {
    label: "Municipal Services",
    value: "MUNICIPAL SERVICES",
  },
  {
    label: "Municipal Taxes",
    value: "MUNICIPAL TAXES",
  },
  {
    label: "Recurring Deposits",
    value: "RECURRING DEPOSIT",
  },

  {
    label: "Rental",
    value: "RENTAL",
  },
  {
    label: "Subscription",
    value: "SUBSCRIPTION",
  },
  {
    label: "Water",
    value: "WATER",
  },
  {
    label: "NCMC",
    value: "NCMC RECHARGE",
  },
  {
    label: "Metro",
    value: "METRO RECHARGE",
  },
  {
    label: "NPS",
    value: "NATIONAL PENSION SYSTEM",
  },
  {
    label: "Prepaid Meter",
    value: "PREPAID METER",
  },
  {
    label: "B2B",
    value: "B2B",
  },
];

const routeType2 = [
  {
    label: "Select route",
    value: "",
  },
  {
    label: "Mobile Recharge",
    value: "MOBILE_RECHARGE",
  },
  {
    label: "Dth Recharge",
    value: "DTH_RECHARGE",
  },
];
const defaultOptions1 = {
  loop: true,
  autoplay: true,
  animationData: animationData1,
};

const B2CTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [currPage, setCurrPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [fromDate, setStartDate] = useState("");
  const [toDate, setEndDate] = useState("");
  const [totalElements, setTotalElements] = useState(10);
  const [statusType, setStatusType] = useState("");
  const [statusTypeErr, setStatusTypeErr] = useState("");

  const [loading, setLoading] = useState(false);
  const [txnLoading, setTxnLoading] = useState(false);
  const [pdfData_, setPdfData] = useState([]);
  const [serviceType, setServiceType] = useState("BBPS");
  const [selectStatus, setSelectStatus] = useState("");
  const [texId, setTexId] = useState("");

  const link = useRef();
  const [downloadLoader, setDownloadLoader] = useState("");
  const [showfilter, setShowFilter] = useState("");
  const [checkStatusMsg, setCheckStatusMsg] = useState({});
  const [txnStatus, setTexnStatus] = useState({});
  const [route, setRoute] = useState("");
  const [refundData, setRefundData] = useState(null);
    const [message, setMessage] = useState({});

  const navigate = useNavigate();

  const { user } = useSelector((state) => state.user);

    const clearRef = useRef(null);
  const clearDate = (callback) => {
    if (clearRef.current) return;
    clearRef.current = callback;
  };

  const constChangeDate = (startDate, endDate) => {
    if (endDate) {
      setEndDate(endDate);
      setStartDate(startDate);
    }
  };

  const onClearDate = () => {
    setEndDate("");
    setStartDate("");
  };


  // Date Format
  var currentDate = new Date();
  var formattedDate = [
    currentDate.getDate(),
    currentDate.getMonth() + 1,
    currentDate.getFullYear(),
  ]
    .map((n) => (n < 10 ? `0${n}` : `${n}`))
    .join("-");

  const transactionData = (parm = {}) => {
    const { key, page, status, serviceT, route_ } = { ...parm };

    let _fromdate = getDateFromDateObj(fromDate, "YYYY-MM-DD");
    let _todate = getDateFromDateObj(toDate, "YYYY-MM-DD");

    if (
      getDateFromDateObj(fromDate, "YYYY-MM-DD") === "Invalid date" ||
      getDateFromDateObj(toDate, "YYYY-MM-DD") === "Invalid date"
    ) {
      _fromdate = "";
      _todate = "";
    }

    console.log("serviceT", serviceT ? serviceT : serviceType);

    let payload = {
      pageNo: currPage,
      pageSize: pageSize,
      status: status ? status : undefined,
      toDate: _todate,
      fromDate: _fromdate,
      txnId: texId,
      userUuid: "",
      serviceType: serviceT ? serviceT : serviceType,
      route: route,
    };

    if (key === "route") {
      payload.route = route_;
    }

    if (key === "CSV" || key === "PDF") {
      payload.pageSize = totalElements;
      if (key === "CSV") {
        setDownloadLoader("CSV");
      } else {
        setDownloadLoader("PDF");
      }
    } else {
      setLoading(true);
    }

    if (key === "pagination") {
      payload.pageNo = page;
      setCurrPage(page);
    } else {
      payload.pageNo = 0;
      setCurrPage(0);
    }
    if (key == "refresh") {
      payload = {
        toDate: "",
        fromDate: "",
        txnId: "",
        serviceType: serviceT ? serviceT : serviceType,
        route: "",
        pageNo: 0,
        pageSize: pageSize,
      };
    }
    getCustomerTxn(payload).then((resp) => {
      setLoading(false);
      if (resp?.data?.success) {
        if (key !== "CSV" && key !== "PDF") {
          setTransactions(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
        } else {
          setPdfData(resp?.data?.data?.content);

          if (key === "CSV") {
            setTimeout(() => {
              const csvlink = link.current;
              csvlink.link.click();
            }, 1);
            setDownloadLoader("");
          } else if (key === "PDF") {
            setDownloadLoader("");

            setTimeout(() => {
              pdfDownload(resp?.data?.data?.content);
            }, 1);
          }
        }
      }
    });
  };

  useEffect(() => {
    transactionData();
  }, []);

  const currentPage = (page) => {
    transactionData({ key: "pagination", page: page, serviceT: serviceType });
  };
  const changStatus = (value = "") => {
    setSelectStatus(value);
    transactionData({ status: value, serviceT: serviceType });
  };
  const changServiceType = (value = "") => {
    setServiceType(value);
    setRoute("");
    setSelectStatus("");
    transactionData({ key: "route", route_: "", serviceT: value, status: "" });
  };

  const navigationDaital = (item) => {
    navigate(`/b2c-transaction/${item?.txnId}`, {
      state: { detail: item, type: "B2C Transaction" },
    });
  };

  useEffect(() => {
    setTimeout(() => {
      setCheckStatusMsg({});
    }, 5000);
  }, []);

  const pdfDownload = (data) => {
    const tableHeader = [
      {
        userFullName: "Customer Name",
        userMobileNumber: "Mobile No.",
        txnId: "Transaction Id",
        amount: "Amount",
        transactionDate: "Date",
        serviceType: "Service Type",
        route: "Route",
        status: "Status",
      },
    ];

    pdfData(data, tableHeader, "B2C-Transaction-History", 550);
  };

  const refresh = () => {
    transactionData({ key: "refresh" });
    setEndDate("");
    setStartDate("");
    setRoute("");
    setTexId("");
    setSelectStatus("");
      if (clearRef.current) {
      clearRef.current();
    }
  };

  const updateStatus = (data) => {
    const params = {
      serviceType: data?.serviceType,
      txnId: data?.txnId,
      status: statusType,
    };
    CustomerTxnSatausUpdate(params)
      .then((resp) => {
        if (resp?.data?.success) {
          setTexnStatus({});
          setCheckStatusMsg({
            msg: resp?.data?.msg,
            type: "success",
          });
          transactionData({ key: "refresh" });
        } else {
          setCheckStatusMsg({
            msg: resp?.data?.msg,
            type: "error",
          });
          setTexnStatus({});
        }
      })
      .catch((err) => {
        setCheckStatusMsg({
          msg: "Something went wrong",
          type: "error",
        });
      });
  };

  const changServiceRoute = (value = "") => {
    setRoute(value);
    transactionData({ key: "route", route_: value, serviceT: serviceType });
  };

    const moreOptions = [

    {
      label:"View Invoice",
      show:(item)=> true,
      click:(item)=>navigationDaital(item),
    },
    {
      label:"Payment Refund",
      show:(item)=>item?.status == "REFUND_PENDING",
      click:(item)=>setRefundData(item),
    },
  ]





   const RefundTransaction = (item) => {
    const payload = {
     txnId : item?.txnId,
  }
  setTxnLoading(true)
  CustomerTxnRefund(payload).then((resp) =>{
    setTxnLoading(false);
    setRefundData(null);
    if(resp?.data?.success){
      setMessage({ msg: resp?.data?.msg, type: "success" });
      
     transactionData({ key: "pagination", page: currPage, serviceT: serviceType});
    }else{
      let msg = "";
            if (resp?.data?.errorCodeList.length > 0) {
              msg = resp?.data?.errorCodeList[0];
            } else {
              msg = resp?.data?.msg;
            }
            setMessage({ msg: msg, type: "error" });
    }
  }).catch((err) =>{
    setRefundData(null);
  });
  
    }
     useEffect(()=>{
    if(isEmpty(message)) return
  const timerId =   setTimeout(() => {
      setMessage({});
    }, 5000);

    return(()=>{
      clearTimeout(timerId);
    })
  },[message])

  return (
    <>
     {!isEmpty(message) && (
            <AlertWrapper className={`${message.type} globle`}>
              <span className="close" onClick={() => setMessage({})}>
                ×
              </span>
              {message.msg}
            </AlertWrapper>
          )}
      <div className="transactions_container">
        <div style={{ padding: "30px" }}>
          <div
            className="transaction_main_container"
            style={{ marginTop: "-10px" }}
          >
            <div className="userlist_head">
              <div className="userlist_heading">
                <div className="userlist_left">
                  <label>B2C Transactions</label>
                </div>
                <div className="userlist_right">
                  {downloadLoader !== "PDF" ? (
                    <button
                      className="pdf"
                      onClick={() => transactionData({ key: "PDF" })}
                    >
                      PDF
                    </button>
                  ) : (
                    <button className="pdf">
                      <div className="btn-loader">
                        <i className="fa-solid fa-spinner"></i>
                      </div>
                    </button>
                  )}

                  {downloadLoader !== "CSV" ? (
                    <button
                      className="xls"
                      onClick={() => transactionData({ key: "CSV" })}
                    >
                      CSV
                    </button>
                  ) : (
                    <button className="xls">
                      <div className="btn-loader">
                        <i className="fa-solid fa-spinner"></i>
                      </div>
                    </button>
                  )}
                  <CSVLink
                    ref={link}
                    data={pdfData_}
                    headers={csvHeader}
                    filename="B2C-ransactionList.csv"
                  ></CSVLink>
                </div>
                <div className="userlist_filter">
                  <button
                    className="filter fs-16"
                    onClick={(e) =>
                      showfilter === "active"
                        ? setShowFilter("")
                        : setShowFilter("active")
                    }
                  >
                    <i className="fa-solid fa-filter"></i>
                  </button>
                </div>
              </div>
            </div>

            <FilterWrapper
              style={{ height: "auto" }}
              className={`display_data ${showfilter}`}
            >
              <div className="filterBox">
                <div className="grow-1">
                  <div className="flex align-items gap-15">
                    <div className="input-field">
                      <select
                        className="input_select_field"
                        value={serviceType}
                        onChange={(e) => changServiceType(e.target.value)}
                      >
                        {subscribedService.map((item) => (
                          <option value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                    <div className="input-field">
                      <select
                        className="input_select_field"
                        value={route}
                        onChange={(e) => changServiceRoute(e.target.value)}
                      >
                        {(serviceType === "BBPS" ? routeType : routeType2).map(
                          (item) => (
                            <option value={item.value}>{item.label}</option>
                          )
                        )}
                      </select>
                    </div>
                    <div className="input-field">
                      <select
                        className="input_select_field"
                        value={selectStatus}
                        onChange={(e) => changStatus(e.target.value)}
                      >
                        <option value={""}>Select Status</option>
                        {statusList.map((item) => (
                          <option value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>

                    <div className="input-field">
                      <div className="flex">
                        <input
                          type="text"
                          placeholder="Transaction ID"
                          value={texId}
                          onChange={(e) => setTexId(e.target.value)}
                        />
                      </div>
                    </div>
                        <DateRangePicker
                    applyDate={constChangeDate}
                    defaultDate={null}
                    onClear={onClearDate}
                    clearDate={clearDate}
                  />

                    {/* <div className="input-field">
                      <div className="flex">
                        <DatePicker
                          showIcon
                          className="date-picker2 date_type"
                          placeholderText="From Date"
                          selected={fromDate}
                          selectsStart
                          valueDefault={null}
                          startDate={fromDate}
                          endDate={toDate}
                          yearDropdownItemNumber={100}
                          scrollableYearDropdown={true}
                          showYearDropdown
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(date) => setStartDate(date)}
                          maxDate={new Date()}
                        />
                      </div>
                    </div>
                    <div className="input-field">
                      <div className="flex">
                        <DatePicker
                          showIcon
                          className="date-picker2 date_type"
                          placeholderText="To Date"
                          selected={toDate}
                          selectsEnd
                          startDate={fromDate}
                          endDate={toDate}
                          minDate={fromDate}
                          yearDropdownItemNumber={100}
                          scrollableYearDropdown={true}
                          showYearDropdown
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(date) => setEndDate(date)}
                          maxDate={new Date()}
                        />
                      </div>
                    </div> */}

                    <div className=" button">
                      <button
                        className="userlist_btn"
                        onClick={() => transactionData({ key: "search" })}
                        style={{ width: "100px" }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="button">
                      <button
                        className="refresh-btn"
                        style={{ width: "60px" }}
                        onClick={refresh}
                      >
                        <i className="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </FilterWrapper>
          </div>

          {transactions && (
            <div className="table-loader">
              {loading && <LocalLoader className="tableLoader" />}
              <TableWrapper className="table-card-wrapper">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Customer Name</th>
                      <th>Mobile</th>
                      <th>Transaction ID</th>
                      <th>Amount</th>
                      <th>Date</th>
                      {/* <th>Service Type</th> */}
                      <th>Route</th>
                      <th>Status</th>
                      {/* <th>Payment Status</th> */}
                      {/* <th>View Invoice</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(transactions) &&
                      transactions.map((item, index) => {
                        const inputDate = new Date(item?.transactionDate);

                        const formattedDate = inputDate.toLocaleString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            hour12: false,
                          }
                        );

                        let color = "";
                        if ((item?.status?.toUpperCase() === "SUCCESS") || item?.status?.toUpperCase() === "REFUNDED") {
                          color = "success";
                        } else if (item?.status?.toUpperCase() === "REFUND_PENDING") {
                          color = "yellow";
                        } else {
                          color = "error";
                        }
                        let color2 = "";
                        if (item?.paymentStatus?.toUpperCase() === "SUCCESS" || item?.paymentStatus?.toUpperCase() === "REFUNDED") {
                          color2 = "success";
                        } else if (item?.paymentStatus?.toUpperCase() === "REFUND_INITIATED") {
                          color2 = "yellow";
                        } else {
                          color2 = "error";
                        }

                        return (
                          <tr key={index}>
                            <td>
                              <span className="card-th">Sr. No.</span>
                              <span className="card-td">
                                {currPage * pageSize + index + 1}
                              </span>
                            </td>

                            <td>
                              <span className="card-th">Customer Name</span>
                              <span className="card-td">
                                {item?.userFullName || "-"}
                              </span>
                            </td>
                            <td>
                              <span className="card-th">Mobile No.</span>
                              <span className="card-td">
                                {item?.userMobileNumber || "-"}
                              </span>
                            </td>
                            <td>
                              <span className="card-th">Transaction ID</span>
                              <span className="card-td">
                                {item?.txnId || "-"}
                              </span>
                            </td>
                            <td>
                              <span className="card-th">Amount</span>
                              <span className="card-td">
                                {item?.amount || "-"}
                              </span>
                            </td>
                            <td>
                              <span className="card-th">Date</span>
                              <span className="card-td">
                                {formattedDate || "-"}
                              </span>
                            </td>
                            {/* <td>
                              <span className="card-th">Service Type</span>
                              <span className=" card-td">
                                {item?.serviceType || "-"}
                              </span>
                            </td> */}
                            <td>
                              <span className="card-th">Route</span>
                              <span className="card-td">{item?.route || "-"}</span>
                            </td>

                            <td>
                              <span className="card-th">Status</span>
                              <span className={"card-td " + color}>
                                {item?.status || "-"}
                              </span>
                            </td>
                            {/* <td>
                              <span className="card-th">Payment Status</span>
                              <span className={"card-td " + color2}>
                                {item?.paymentStatus || "-"}
                              </span>
                            </td> */}
                            <td className="user_action_btn button">
                              <span className="card-th">Action</span>
                              <span>
                                <MoreOptions options={moreOptions} items={item} />
                              </span>
                            </td>
                            {/* <td className="user_action_btn button">
                              <span className="card-th">Action</span>
                              <span>
                              
                                <button onClick={() => {
                                     setStatusType(item?.status);
                                  setTexnStatus(item);
                             

                                }}>
                              <i className="fa fa-refresh"></i>
                              </button>
                              </span>
                            </td> */}
                          </tr>
                        );
                      })}

                    {isEmpty(transactions) && !loading && (
                      <tr style={{ textAlign: "center" }}>
                        <td
                          colspan="100%"
                          style={{ textAlign: "center", color: "red" }}
                        >
                          No Transaction Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </TableWrapper>
            </div>
          )}

          {!isEmpty(checkStatusMsg) && (
            <AlertWrapper className={`${checkStatusMsg.type} globle`}>
              <span className="close" onClick={() => setCheckStatusMsg({})}>
                ×
              </span>
              {checkStatusMsg.msg}
            </AlertWrapper>
          )}

          {totalPages > 1 && (
            <Pagination
              items={transactions}
              itemsPerPage={pageSize}
              setitemsPerPage={setPageSize}
              currentPage={currPage}
              setcurrentPage={currentPage}
              totalPages={totalPages}
              forcePage={currPage}
            />
          )}
        </div>
      </div>
      {!isEmpty(txnStatus) && (
        <ConfirmBox
          cancel={() => setTexnStatus({})}
          ok={() => updateStatus(txnStatus)}
          height={"360px"}
        >
            <div>
            <label>You want to update transaction status?</label>
          <div className="center">
            <div className="role role_responsive" style={{ width: "200px" }}>
              <div className="">
                <div className="labelname">
                  <label>Status</label>
                  <span className="required"> *</span>
                </div>
                <div className="input-field">
                  <select
                    className="input_select_field"
                    value={statusType}
                    name="statusType"
                    onChange={(e) => {
                      setStatusType(e.target.value);
                      setStatusTypeErr("");
                    }}
                  >
                    <option value={""}>Select Status</option>
                    {statusList.map((item) => (
                      <option value={item.value}>{item.label}</option>
                    ))}
                  </select>
                  {statusTypeErr && (
                    <p className="error fs-12 mt-10">{statusTypeErr}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
            </div>
        </ConfirmBox>
      )}
       {refundData && <ConfirmBox cancel={()=>setRefundData(null)} ok={() => RefundTransaction(refundData)}>
                 <label>You want to refund this transaction?</label>
                 </ConfirmBox>}
    </>
  );
};

export default B2CTransactions;
